import { useState } from 'react';

import { Block } from '@attom';

import CS from './PureTab.module.scss';

export const PureTab = ({
	children,
	// box control
	boxClass = '',
	boxSpace = '',
	boxSize = '',
	// custom props:
	titleArray = [],
	activeTabIndex = 0,
	// styles
	headerClass = '',
	headerItemClass = '',
	bodyClass = '',
	...props
}) => {
	//
	const [activeIndex, setActiveIndex] = useState(activeTabIndex || 0);

	const Titles = titleArray.map((title, i) => (
		<div
			key={i}
			onClick={() => {
				setActiveIndex(i);
			}}
			className={`${CS.titleItem} ${headerItemClass}`}
			_status={i === activeIndex ? 'active' : 'deactive'}
		>
			{typeof title === 'function' ? title() : title}
		</div>
	));

	const Contents = (children && children[activeIndex]) || null;

	return (
		<Block boxClass={boxClass} boxSize={boxSize} boxSpace={boxSpace} {...props}>
			<div className={CS.container}>
				<div className={`${CS.header} ${headerClass} tab-header`}>{Titles}</div>
				<div className={bodyClass}>{Contents}</div>
			</div>
		</Block>
	);
};
